export const Youtube = ({ className }: { className: string }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_11327_130)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5177 3.45312H3.59293C1.55219 3.45312 -0.148438 5.10667 -0.148438 7.46887V14.3193C-0.148438 16.5634 1.55219 18.4531 3.59293 18.4531H16.4043C18.4451 18.4531 20.1457 16.5634 20.1457 14.3193V7.46887C20.1457 5.22478 18.5584 3.45312 16.5177 3.45312ZM7.90118 14.3193V7.70509L13.4566 11.0122L7.90118 14.3193Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11327_130">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.453125)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
